import { render } from "./About.vue?vue&type=template&id=dee451b0"
const script = {}
script.render = render

export default script